<template>
  <iv-Dropdown
    class="DropdownSlider"
    :visible="visible"
    :transfer="transfer"
    :size="size"
    trigger="custom"
    placement="bottom-start"
    @on-clickoutside="onVisibleChange(false)">
      <iv-Input
        type="text"
        :value="inputVal"
        :disabled="disabled"
        @on-change="onChange($event.target.value)"
        @on-focus="onVisibleChange(true)"
        @on-blur="onVisibleChange(false)" />
      <iv-DropdownMenu
        class="DropdownSliderMenu"
        slot="list">
        <div class="DropdownSliderMenu__inner">
          <span>{{minimum}}</span>
          <iv-Slider
            :value="sliderVal"
            :max="maxium"
            :min="minimum"
            :step="step"
            :show-stops="showStops"
            @on-change="onSliderChange($event, true)"
            @on-input="onSliderChange($event, false)"></iv-Slider>
          <span>{{maxium}}</span>
        </div>
      </iv-DropdownMenu>
  </iv-Dropdown>
</template>
<script>
export default {
  name: "DropdownSlider",
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    disabled: Boolean,
    value: {
      type: [String, Number],
      default: ""
    },
    transfer: Boolean,
    maxium: {
      type: Number,
      default: 7,
    },
    minimum:{
      type: Number,
      default: 0,
    },
    step:{
      type: Number,
      default: 0.5
    },
    showStops: Boolean,
    size: {
      type: String,
      default: 'default'
    },
    debug: Boolean,
  },
  data(){
    return {
      visible: false,
      sliderVal: typeof this.value == 'number'?this.value:0,
      inputVal: this.value,
      continueSliderChange: false,
    }
  },
  watch:{
    value(val){
      this.sliderVal = typeof this.value == 'number'?this.value:0
      this.inputVal = val
      if(this.debug) console.log("watch::value=%s::sliderVal=%s::inputVal=%s", val, this.sliderVal, this.inputVal)
      this.continueSliderChange = true
      this.$nextTick(()=>{ //避免sliderVal值变化时触发onSliderChange，影响输入框显示的值。
        this.continueSliderChange = false
      })
    }
  },
  methods: {
    onVisibleChange(val){
      if(this.disabled) val=false
      this.visible = val
    },
    onChange(val){
      this.$emit('change', val)
    },
    onSliderChange(val, output=false){
      if(output) this.$emit('change', val)
      if(!this.continueSliderChange) this.inputVal = val
      if(this.debug) console.log("continueSliderChange::%s", this.continueSliderChange)
      if(this.debug) console.log("onSliderChange::%s::%s", val, output)
    }
  }
}
</script>
<style lang="scss" scoped>
.DropdownSlider{}
.DropdownSliderMenu{
  min-width: 200px;
}
.DropdownSliderMenu__inner{
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
}
.DropdownSliderMenu__inner > span{
  flex-shrink: 1;
  width: 2em;
  display:block;
  text-align: center;
  line-height: 3em;
}
.DropdownSliderMenu__inner > div{
  flex-grow: 1;
}
</style>
